import { ButtonProps } from "@mui/material";
import { CarButton } from "./Buttons";
import { useNavigate } from "react-router-dom";
import { useScrollTo } from "@app/hooks/useScrollToTop";

interface CarNavigateButtonProps extends Omit<ButtonProps, "onClick"> {
  url: string;
  scrollToTop?: boolean;
}

export const CarNavigateButton = ({
  url,
  scrollToTop,
  ...props
}: CarNavigateButtonProps) => {
  const navigate = useNavigate();
  const scrollTo = useScrollTo();

  const handleNavigate = () => {
    navigate(url);
    if (scrollToTop) {
      scrollTo("top");
    }
  };

  return <CarButton onClick={handleNavigate} {...props} />;
};
